import React, { useContext } from 'react';
import { CLUB_WOWCHER_LEVELS } from '../brands/default/config';
import { CURRENCY_SYMBOL } from '../brands/default/constants';
import { clubWowcherLevelToColor } from '../helpers/clubWowcher';
import ThemeContext from '../providers/ThemeProvider';

const VipDetailsTable = () => {
  const theme = useContext(ThemeContext);

  return (
    <div className="table-content">
      <table>
        <thead className="table-head">
          <tr style={{ borderRadius: '20px', outlineStyle: 'groove' }}>
            <th
              className="round-benefits"
              style={{
                backgroundColor: `${theme.colors.primary}`,
                width: '75%',
              }}
            >
              Benefits
            </th>
            <th className="round">Basic</th>
            <th
              className="round-end"
              style={{
                color: 'black',
              }}
            >
              VIP
            </th>
          </tr>
        </thead>
        <tbody className="table-body">
          <tr>
            <td style={{ paddingTop: '8px' }}>
              Great Deals and fantastic savings
            </td>
            <td>
              <span className="table-content__check">&#10003;</span>
            </td>
            <td>
              <span className="table-content__check">&#10003;</span>
            </td>
          </tr>
          <tr>
            <td>Exclusive VIP offers</td>
            <td />
            <td>
              <span className="table-content__check">&#10003;</span>
            </td>
          </tr>
          <tr>
            <td>{`Discount codes worth ${CURRENCY_SYMBOL}50`}</td>
            <td />
            <td>
              <span className="table-content__check">&#10003;</span>
            </td>
          </tr>
          <tr>
            <td>Early bird access to deals</td>
            <td />
            <td>
              <span className="table-content__check">&#10003;</span>
            </td>
          </tr>
          <tr>
            <td>Free competition entries</td>
            <td />
            <td>
              <span className="table-content__check">&#10003;</span>
            </td>
          </tr>
          <tr>
            <td>VIP customer service - 24h response!</td>
            <td />
            <td>
              <span className="table-content__check">&#10003;</span>
            </td>
          </tr>
        </tbody>
      </table>
      <style global jsx>{`
        table {
          border-collapse: separate;
          color: white;
          font-size: 16px;
          width: 100%;
        }
        .table-content {
          margin-bottom: 20px; /* Add margin between thead and tbody */
        }
        .table-body {
          margin-top: 20px;
        }
        th:first-child,
        td:first-child {
          width: 70%;
        }
        th,
        td {
          padding: 0.1em;
        }
        th {
          font-weight: bold;
        }
        td {
          border: none;
        }
        .round {
          padding: 0.2em;
          padding-left: 1.3em;
          border-bottom-right-radius: 20px;
          border-top-right-radius: 20px;
        }
        .round-benefits {
          padding: 0.2em;
          padding-left: 1%;
          border-radius: 20px;
        }
        .round-end {
          padding: 0.2em;
          padding-left: 2em;
          border-bottom-right-radius: 20px;
          border-top-right-radius: 20px;
          background-image: radial-gradient(
            circle at left center,
            rgba(0, 0, 0, 0) 0,
            rgba(0, 0, 0, 0) 15px,
            ${clubWowcherLevelToColor(CLUB_WOWCHER_LEVELS.Silver)} 20px
          );
          width: 14%;
        }
        .table-content__check {
          padding-left: 45%;
        }
        @media (max-width: ${theme.breakpoints.smDown}) {
          .round {
            padding: 0.1em;
            padding-left: 0.3em;
            border-radius: 1em;
          }
          .round-end {
            width: 18%;
            padding-left: 1.2em;
            background-image: radial-gradient(
              circle at left center,
              rgba(0, 0, 0, 0) 0,
              rgba(0, 0, 0, 0) 15px,
              ${clubWowcherLevelToColor(CLUB_WOWCHER_LEVELS.Silver)} 10px
            );
          }
          .round-benefits {
            padding: 0.1em;
            padding-left: 2%;
            border-radius: 1em;
          }
          .table-content__check {
            padding-left: 40%;
          }
        }
        .round::before,
        .round::after {
          content: '';
          display: block;
          position: absolute;
          top: 0;
          bottom: 0;
          width: 0.5em;
          margin: 5px;
        }

        .round::before {
          left: -1px;
          border-top-left-radius: 0.5em;
          border-bottom-left-radius: 0.5em;
        }

        .round::after {
          right: -1px;
          border-top-right-radius: 0.5em;
          border-bottom-right-radius: 0.5em;
        }
      `}</style>
    </div>
  );
};

export default VipDetailsTable;
